import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import imagem1 from "../../images/imagem13.jpg";
import Globais from "../../css/Globais";
import familiaResort from "../../images/familia-resort.jpg";

const SectionWrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  border-top: 1px solid #eee;
  text-align: center;

  @media (min-width: 768px) {
    padding: 6rem 4rem;
  }
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #222;

  @media (min-width: 768px) {
    font-size: 2.4rem;
  }
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const BulletList = styled.ul`
  text-align: left;
  margin: 0 auto 2rem;
  max-width: 600px;
  padding-left: 1rem;

  li {
    font-size: 1rem;
    margin-bottom: 1rem;
    color: #444;
  }
`;

const Quote = styled.blockquote`
  font-size: 1.2rem;
  font-style: italic;
  color: #333;
  margin-bottom: 2.5rem;

  strong {
    font-weight: 700;
    color: #0077cc;
  }
`;
const CTAButton = styled.a`
  display: inline-block; /* importante */
  max-width: 100%; /* evita overflow */
  text-align: center;
  background-color: #0077cc;
  color: white;
  padding: 0.9rem 1.8rem;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 6px;
  transition: background 0.3s ease;
  word-break: break-word; /* força quebra de linha em dispositivos pequenos */

  &:hover {
    background-color: #005fa3;
  }
`;



const ViewComprar = () => {
  return (
    <SectionWrapper>
      <Content>
        <Title>Não encontrou a cota ideal?<br/><br/>Avise a gente o que você procura — <br/>e te avisamos assim que aparecer!</Title>

        <Paragraph>
          Sabemos que nem sempre a cota perfeita está disponível no momento da sua busca. Por isso, criamos esse canal para que você registre seu interesse e deixe com a gente a missão de te avisar assim que surgir uma oportunidade.
        </Paragraph>

           <Paragraph>
          <strong>Basta preencher com os empreendimentos e características que você procura, e assim que tivermos uma cota compatível, nossa equipe entrará em contato.</strong>
        </Paragraph>

        <BulletList>
          <li>🧭 Você não perde nenhuma oportunidade</li>
          <li>🤝 Nosso time busca para você</li>
          <li>🏖️ Só multipropriedades em destinos turísticos de destaque</li>
        </BulletList>

        <CTAButton href="#formulario">
          Quero receber oportunidades de compra de cota
        </CTAButton>
      </Content>
    </SectionWrapper>
  );
};


export default ViewComprar;



